import React, { useEffect } from 'react';
import { setSelectedAdditionalFormInputData } from '../../../../redux/checkoutredux/actions/checkoutactions/checkoutActions'; 


const BlockTerms = ({store}) => {
  //let woocommerce_pay_order_before_submit = store.getState().checkouthooks.checkoutHooks?.woocommerce_pay_order_before_submit || "";
  let woocommerce_pay_order_before_submit = store.getState().generalsettings.generalSettings.checkouthooks?.woocommerce_pay_order_before_submit || "";
  //console.log("The Terms: ",woocommerce_pay_order_before_submit);


  

  /*
  useEffect(() => {
    // Funktion zum Extrahieren der Formulardaten
    const extractFormData = () => {
     
      const inputRegex = /<input(?:[^>]*?\sname="(.*?)")?(?:[^>]*?\svalue="(.*?)")?(?:[^>]*?\schecked(?:="checked")?)?(?:[^>]*)>/g;
      

      let match;
      const extractedFormData = {};

      while ((match = inputRegex.exec(woocommerce_pay_order_before_submit)) !== null) {
        const [, name, value] = match;
        extractedFormData[name] = value;
      }

      console.log("EXTRACT DATA: ",extractedFormData);

      store.dispatch(setSelectedAdditionalFormInputData(extractedFormData));
    };

    // Aufruf der Funktion zum Extrahieren der Formulardaten
    extractFormData();
  }, [woocommerce_pay_order_before_submit]);
*/


  return (
    <div className="container">
      <div className="row">
        {/*}
        <div className="col-lg-12">
          <div className="ips-checkbox-placeholder ips-checkbox-placeholder-legal" data-checkbox="terms">
            <p className="legal form-row checkbox-legal validate-required" data-checkbox="terms">
              <div className="woocommerce-privacy-policy-text"></div>
              <label htmlFor="legal" className="woocommerce-form__label">
                <span className="woocommerce-ips-legal-checkbox-text">Mit deiner Bestellung erklärst du dich mit unseren <a href="https://dev2.buecherbuechse.de/agb/" target="_blank">Allgemeinen Geschäftsbedingungen</a>, <a href="https://dev2.buecherbuechse.de/widerrufsbelehrung/" target="_blank">Widerrufsbestimmungen</a> und <a href="https://dev2.buecherbuechse.de/datenschutzbelehrung/" target="_blank">Datenschutzbestimmungen</a> einverstanden.</span>
              </label>
              <input type="hidden" name="legal-field" value="1" className="" />
              <input type="hidden" name="terms" value="1" className="garlic-auto-save" data-parsley-multiple="terms" />
            </p>
          </div>
        </div>
        */}
        <div className="col-lg-12">

       { <div dangerouslySetInnerHTML={{ __html: woocommerce_pay_order_before_submit }} /> }
          </div>

      </div>
    </div>
  );
};

export default BlockTerms;